import { render, staticRenderFns } from "./WatchMovieModal.vue?vue&type=template&id=516d6e88&"
import script from "./WatchMovieModal.vue?vue&type=script&lang=js&"
export * from "./WatchMovieModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports